(function () {
    'use strict';
    angular.module('Const').constant('reasonForClaims', [
        'damaged',
        'lost',
        'stolen',
        'others'
    ])
})();


// WEBPACK FOOTER //
// ./js/consts/reason-for-claims-const.js